import React, { useEffect } from 'react';
import { Icon } from '../Icon';
import { Button } from '../Button';
import './CustomDialog.css';

export interface CustomDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  type?: 'info' | 'success' | 'error' | 'warning' | 'confirm';
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  showCancel?: boolean;
}

export const CustomDialog: React.FC<CustomDialogProps> = ({
  isOpen,
  onClose,
  title,
  message,
  type = 'info',
  confirmText = 'OK',
  cancelText = 'Отмена',
  onConfirm,
  onCancel,
  showCancel = false,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    }
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return { name: 'check-circle', color: '#34C759' };
      case 'error':
        return { name: 'alert-circle', color: '#FF3B30' };
      case 'warning':
        return { name: 'alert-triangle', color: '#FF9500' };
      case 'confirm':
        return { name: 'help-circle', color: '#007AFF' };
      default:
        return { name: 'info', color: '#007AFF' };
    }
  };

  const icon = getIcon();

  return (
    <div className="custom-dialog-overlay" onClick={handleCancel}>
      <div className="custom-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="custom-dialog__icon">
          <Icon name={icon.name} size={48} color={icon.color} />
        </div>
        
        {title && <div className="custom-dialog__title">{title}</div>}
        
        <div className="custom-dialog__message">{message}</div>

        <div className="custom-dialog__actions">
          {showCancel && (
            <Button
              variant="secondary"
              onClick={handleCancel}
              fullWidth
            >
              {cancelText}
            </Button>
          )}
          <Button
            variant="primary"
            onClick={handleConfirm}
            fullWidth
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

